import React, { createContext, useContext, useReducer } from "react";
import UsersReducer from "../reducers/UsersReducer";
import UserService from "../services/UserService";
import { USERS_RECIBIDOS } from "../types";
import { hideModal } from "../utils";
import { ModalContext } from "./ModalContext";

const initialState = {
  users: null,
  user: null,
};

export const UsersContext = createContext(initialState);

export const UsersProvider = ({ children }) => {
  const [state, dispatch] = useReducer(UsersReducer, initialState);

  const { success } = useContext(ModalContext);

  const getUsers = (filters) => {
    UserService.getAllUsers(filters).then((res) => {
      const { users } = res.data;
      dispatch({ type: USERS_RECIBIDOS, payload: users });
    });
  };

  const getAllbranchScopes = (filters) => {
    UserService.getbranchScopes(filters).then((res) => {
      const { users } = res.data;
      dispatch({ type: USERS_RECIBIDOS, payload: users });
    });
  }

  const createUser = (data) => {
    UserService.postUser(data).then(() => {
      getUsers();
      hideModal();
      success("Usuario creado con éxito.");
    });
  };

  const updateUser = (data) => {
    UserService.putUser(data).then(() => {
      getUsers();
      hideModal();
      success("Usuario actualizado con éxito.");
    });
  };

  const deleteUser = (user_id) => {
    UserService.deleteUser(user_id).then(() => {
      getUsers();
      hideModal();
      success("Usuario elminado con éxito.");
    });
  };

  const clearUsers = () => {
    dispatch({ type: USERS_RECIBIDOS, payload: null });
  };

  return (
    <UsersContext.Provider
      value={{
        ...state,
        getUsers,
        getAllbranchScopes,
        createUser,
        updateUser,
        deleteUser,
        clearUsers,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};
